import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { ITasksState } from '.';
import { api } from '../../api/api';

export const viewJoinChannelsTasks = createAsyncThunk<void, number>(
    'viewJoinChannel',
    (taskId: number) => api.tasks.viewJoinChannel(taskId)
);

const viewJoinTasksHandler = (builder: ActionReducerMapBuilder<ITasksState>) => {
    builder
        .addCase(viewJoinChannelsTasks.pending, () => {})
        .addCase(viewJoinChannelsTasks.fulfilled, () => {})
        .addCase(viewJoinChannelsTasks.rejected, () => {});
};

export default viewJoinTasksHandler;